import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ArrowLeft, ArrowRight, SkipForward } from 'lucide-react';

const OnboardingNavigationBar = ({
    onBack,
    onNext,
    onSkip,
    showBack = true,
    showNext = true,
    showSkip = false,
    nextLabel = 'Nästa',
    backLabel = 'Tillbaka',
    skipLabel = 'Hoppa över',
    nextDisabled = false,
    saving = false,
}) => {
    return (
        <>
            <style>{`
                .onboarding-nav {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1.25rem 0;
                    margin-top: 1.5rem;
                    border-top: 1px solid #f1f5f9;
                }
                .onboarding-nav-left {
                    display: flex;
                    gap: 0.75rem;
                }
                .onboarding-nav-right {
                    display: flex;
                    gap: 0.75rem;
                }
                .onboarding-btn-back {
                    background: transparent;
                    border: 1px solid #e2e8f0;
                    color: #64748b;
                    padding: 0.5rem 1.25rem;
                    border-radius: 8px;
                    font-weight: 500;
                    font-size: 0.875rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    transition: all 0.15s;
                }
                .onboarding-btn-back:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                    color: #374151;
                }
                .onboarding-btn-skip {
                    background: transparent;
                    border: 1px solid #e2e8f0;
                    color: #94a3b8;
                    padding: 0.5rem 1.25rem;
                    border-radius: 8px;
                    font-weight: 500;
                    font-size: 0.875rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    transition: all 0.15s;
                }
                .onboarding-btn-skip:hover {
                    background: #f8fafc;
                    color: #64748b;
                }
                .onboarding-btn-next {
                    background: var(--primary);
                    border: none;
                    color: white;
                    padding: 0.5rem 1.5rem;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 0.875rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    transition: all 0.15s;
                }
                .onboarding-btn-next:hover:not(:disabled) {
                    opacity: 0.9;
                    transform: translateY(-1px);
                }
                .onboarding-btn-next:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            `}</style>
            <div className="onboarding-nav">
                <div className="onboarding-nav-left">
                    {showBack && (
                        <button className="onboarding-btn-back" onClick={onBack}>
                            <ArrowLeft size={16} />
                            {backLabel}
                        </button>
                    )}
                </div>
                <div className="onboarding-nav-right">
                    {showSkip && (
                        <button className="onboarding-btn-skip" onClick={onSkip}>
                            <SkipForward size={16} />
                            {skipLabel}
                        </button>
                    )}
                    {showNext && (
                        <button
                            className="onboarding-btn-next"
                            onClick={onNext}
                            disabled={nextDisabled || saving}
                        >
                            {saving ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                <>
                                    {nextLabel}
                                    <ArrowRight size={16} />
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default OnboardingNavigationBar;
